import radium from 'radium';
import Section from "../../../components/section/Section";
import SectionTitle from "../../../components/sectionTitle/SectionTitle";
import AddressData from "./AddressData";

function CustomerAddressData(props) {
	const addressesDiffer = props.addressesDiffer
	const style = {
		sectionContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			width: '100%',
			'@media (min-width : 768px)': {
				justifyContent: 'space-between',
			}
		}, section: {
			width: '100%',
			'@media (min-width : 768px)': {
				width: '50%',
			}
		},
		sectionLeft: {
			'@media (min-width : 768px)': {
				paddingRight: '1em'
			}
		},
		sectionRight: {
			'@media (min-width : 768px)': {
				paddingLeft: '1em'
			}
		}
	}
	return (
		<div style={style.sectionContainer}>
			<Section style={[style.section,style.sectionLeft]}>
				<SectionTitle headlineLevel={"h2"}>
					Versandadresse
				</SectionTitle>
					<AddressData address={props.shipmentAddress}/>
			</Section>
			<Section style={[style.section,style.sectionRight]}>
				<SectionTitle headlineLevel={"h2"}>
					Rechnungsadresse
				</SectionTitle>
				{addressesDiffer ?
					<AddressData address={props.legalAddress} />
					:

					<div className="address">
						<div>gleich wie Versandadresse</div>
					</div>

				}
			</Section>
	</div>
)
	;
}

export default radium(CustomerAddressData);
